/* globals adobe */
(function (window, angular, undefined) {
angular.module('formApp', ['ngMessages', 'ui.router', 'ngSanitize', 'templates', 'angular-uuid'])
.controller('MainController', ['$scope', '$window','$rootScope', 'FormService', 'updateHeader', '$state', 'LoadingInterceptor', '$log', 'sessionService', 'errorHandler', '$location', 'dataUtils',
function ($scope, $window, $rootScope, formService, updateHeader, $state, loadingInterceptor, $log, sessionService, errorHandler, $location, dataUtils) {

sessionService.init();
$rootScope.windowWidth = $window.innerWidth;
$scope.pet = {};

$scope.state = $state;

$scope.updateHeaderImage = updateHeader;

$scope.schema = undefined;

$scope.gatewayReady = false;

// gets product title by ID from AEM content 
$scope.getProductTitle = function (id, map) {
return dataUtils.getProductTitle(id);
};

$scope.getProductPlan = function (id, map) {
return dataUtils.getProductPlan(id);
};

loadingInterceptor.incrementRequests();

formService.init().then(function (response) {
formService.getSchema().then(function (response) {
$scope.schema = response.data;
loadingInterceptor.decrementRequests();
$scope.gatewayReady = true;
}).catch(function (e) {
errorHandler.reportErrors(e, 'redirect', 'in1t5c');
});
}).catch(function (e) {
errorHandler.reportErrors(e, 'redirect');
});

//?campaign=phdrct10&brav=xxxxxxxx

// campaign logic - see also retrieve-quote.controller.js
$scope.pah = false;
$scope.pahvip = false;
$scope.pahvipa = false;
$scope.pahvipb = false;
$scope.amz = false;
$scope.idt = 'false';
$scope.saevent = false;

var campaign,
brav;

var search = $location.search();
var params = {};
angular.forEach(search, function (value, key) {
var keyName = key.toLowerCase();
if (keyName === 'campaign' || keyName === 'brav') {
if (typeof value === 'string' && value !== "") {
    params[keyName] = value.toUpperCase();

}
}
});


function setcookie(cookieName, cookieValue) {
var today = new Date();
var expire = new Date();
expire.setTime(today.getTime() + 3600000 * 24 * 14);
document.cookie = cookieName + "=" + encodeURI(cookieValue) + ";expires=" + expire.toGMTString();
}
function getCookie(name) {
var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
return v ? v[2] : null;
}

if (params.campaign && !sessionStorage.getItem('campaign')) {
$scope.campaign = params.campaign;
sessionStorage.setItem('campaign', $scope.campaign);
setcookie('campaign', $scope.campaign);
}
if (params.campaign && !getCookie('campaign')) {
$scope.campaign = params.campaign;
sessionStorage.setItem('campaign', $scope.campaign);
setcookie('campaign', $scope.campaign);
}
if (params.campaign && getCookie('campaign')) {
$scope.campaign = params.campaign;
sessionStorage.setItem('campaign', $scope.campaign);
setcookie('campaign', $scope.campaign);
}

if (!params.campaign && getCookie('campaign')) {
$scope.returnCampaign = 'Y';
$scope.campaign = getCookie('campaign');
}

if (sessionStorage.getItem('campaign')) {
$scope.campaign = sessionStorage.getItem('campaign');
}

if (params.brav && !sessionStorage.getItem('brav')) {
$scope.brav = params.brav;
sessionStorage.setItem('brav', $scope.brav);
}

if (sessionStorage.getItem('brav')) {
$scope.brav = sessionStorage.getItem('brav');
}

$scope.$watch('campaign', function (newVal, oldVal) {
if (newVal) {

    var campaignCode = newVal.toUpperCase(), pah, newurl, amz;
    var eQuote = sessionStorage.getItem('eQuote');
    if (['PHDRCT10', 'PHMC10', 'PHPPC10', 'PHSOC10', 'PHSTOR10', 'PAHEQUOTE', 'PAH', 'PHSTORA', 'PHPPCA', 'PHPPCB'].indexOf(campaignCode) !== -1) {
        $scope.pah = true;
        $rootScope.partnerName = 'Pets at Home';
        $rootScope.campaignCode = campaignCode;

        var partner = $location.search().partner;

        if ($scope.returnCampaign !== 'Y' && history.pushState && typeof partner === 'undefined' && !eQuote) {
            pah = "&partner=PAH";
            newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + decodeURIComponent(window.location.search + pah);
            window.history.pushState({ path: newurl }, '', newurl);
        }

    } else {
        $scope.pah = false;
    }

    if (['PHVIP10', 'PHVIPH10'].indexOf(campaignCode) !== -1) {

        $scope.pahvip = true;
        $rootScope.partnerName = 'Pets at Home VIP';
        $rootScope.campaignCode = campaignCode;

        if ($scope.returnCampaign !== 'Y' && history.pushState && !eQuote) {
            pah = "&partner=PAH";
            newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + decodeURIComponent(window.location.search + pah);
            window.history.pushState({ path: newurl }, '', newurl);
        }

    } else {
        $scope.pahvip = false;
    }

    if (['PHVIPA', 'PHVIPHA'].indexOf(campaignCode) !== -1) {

        $scope.pahvipa = true;
        $rootScope.partnerName = 'Pets at Home VIP A';
        $rootScope.campaignCode = campaignCode;

        if ($scope.returnCampaign !== 'Y' && history.pushState && !eQuote) {
            pah = "&partner=PAH";
            newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + decodeURIComponent(window.location.search + pah);
            window.history.pushState({ path: newurl }, '', newurl);
        }

    } else {
        $scope.pahvipa = false;
    }

    if (['PHVIPB', 'PHVIPHB'].indexOf(campaignCode) !== -1) {

        $scope.pahvipb = true;
        $rootScope.partnerName = 'Pets at Home VIP B';
        $rootScope.campaignCode = campaignCode;

        if ($scope.returnCampaign !== 'Y' && history.pushState && !eQuote) {
            pah = "&partner=PAH";
            newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + decodeURIComponent(window.location.search + pah);
            window.history.pushState({ path: newurl }, '', newurl);
        }

    } else {
        $scope.pahvipb = false;
    }

    if (['AMZNDISP', 'AMZNFBK', 'AMZNFR', 'AMZNQR'].indexOf(campaignCode) !== -1) {
        $scope.amz = true;
        $rootScope.partnerName = 'Amazon';
        $rootScope.campaignCode = campaignCode;

        if ($scope.returnCampaign !== 'Y' && history.pushState && !eQuote) {
            amz = "&partner=AMZ";
            newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + decodeURIComponent(window.location.search + amz);
            window.history.pushState({ path: newurl }, '', newurl);
        }

        $scope.AMZNDISP = campaignCode === 'AMZNDISP' ? true : false;

    } else {
        $scope.amz = false;
    }

    if (['SAEVENT'].indexOf(campaignCode) !== -1) {
        $scope.saevent = true;
        $rootScope.partnerName = 'saevent';
        $rootScope.campaignCode = campaignCode;

        if ($scope.returnCampaign !== 'Y' && history.pushState && !eQuote) {
            var saevent = "&partner=SAEVENT";
            newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + decodeURIComponent(window.location.search + saevent);
            window.history.pushState({ path: newurl }, '', newurl);
        }
    } else {
        $scope.saevent = false;
    }

}

if ($scope.pah === true || $scope.pahvip === true || $scope.pahvipa === true || $scope.pahvipb === true) {
$rootScope.campaignFunnel = 4;
sessionStorage.setItem('scPartnerName ', 'PAH');
} else if ($scope.amz === true) {
$rootScope.campaignFunnel = 1;
sessionStorage.setItem('scPartnerName ', 'AMZ');
} else {
$rootScope.campaignFunnel = 1;
sessionStorage.setItem('scPartnerName ', 'FALSE');
}

});

// ---------------------- Boldchat --------------------------//
$scope.$on('$locationChangeSuccess', function (event) {
if (window.hasOwnProperty('_bcvma') && angular.isArray(_bcvma) && window.hasOwnProperty('pageViewer') && angular.isFunction(pageViewer.load)) {
_bcvma.push(["pageViewed"]);
pageViewer.load();
}

if (typeof window.rTapNotifyDOMChange === "function") {
window.rTapNotifyDOMChange(document.getElementById('skipnav'));
}
});

$scope.rTapClick = function ($event) {
if (typeof window.rTapClickToCall === "function") {
$event.preventDefault();
}
};

}]);
})(window, window.angular);